/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddGatewayMerchantDataRequest} from '@cash-web/protos/squareup/roster/gateway.pb'
import {AddGatewayMerchantDataResponse} from '@cash-web/protos/squareup/roster/gateway.pb'


export const add = (request: AddGatewayMerchantDataRequest, options?: CashRequestOptions) => post<AddGatewayMerchantDataRequest, AddGatewayMerchantDataResponse>("/2.0/cash/add", request, {...options, rejectOnError: true })